export const BASE_TITLES = {
  id: {
    base: '№',
    plural: '№',
    group: 'Группа №',
  },
  company: {
    base: 'Заказчик',
    plural: 'Заказчики',
    group: 'Группа заказчиков',
  },
  contract: {
    base: 'Контракт',
    plural: 'Контракты',
    group: 'Группа контрактов',
  },
  customer: {
    base: 'Абонент',
    plural: 'Абоненты',
    group: 'Группа абонентов',
  },
  manager: {
    base: 'Менеджер',
    plural: 'Менеджеры',
    group: 'Группа менеджеров',
  },
  workers: {
    base: 'Исполнитель',
    plural: 'Исполнители',
    group: 'Группа исполнителей',
    editPlural: 'Редактировать исполнителей',
  },
  address: {
    base: 'Адрес',
    plural: 'Адреса',
    group: 'Группа адресов',
  },
  taskLocation: {
    base: 'Место установки',
    plural: 'Места установки',
    group: 'Группа мест установки',
  },
  deviceType: {
    base: 'Вид работ',
    plural: 'Виды работ',
    group: 'Группа видов работ',
  },
  createdDate: {
    base: 'Дата создания',
    plural: 'Даты создания',
    group: 'Группа дат создания',
  },
  executedDate: {
    base: 'Дата выполнения',
    plural: 'Даты выполнения',
    group: 'Группа дат выполнения',
  },
  status: {
    base: 'Статус',
    plural: 'Статусы',
    group: 'Группа статусов',
  },
  price: {
    base: 'Стоимость',
    plural: 'Стоимости',
    group: 'Группа стоимостей',
  },
  viewRequest: {
    base: 'Просмотр заявки',
    plural: 'Просмотры заявок',
    group: 'Группа просмотров заявок',
  },
  director: {
    base: 'Руководитель',
    plural: 'Руководители',
    group: 'Группа руководителей',
  },
  functionalAdmin: {
    base: 'Функциональный администратор',
    plural: 'Функциональные администраторы',
    group: 'Группа функциональных администраторов',
  },
  projectManager: {
    base: 'Проектный менеджер',
    plural: 'Проектные менеджеры',
    group: 'Группа проектных менеджеров',
  },
  admin: {
    base: 'Администратор',
    plural: 'Администраторы',
    group: 'Группа администраторов',
  },
  guest: {
    base: 'Гость',
    plural: 'Гости',
    group: 'Группа гостей',
  },
  apartment: {
    base: 'Квартира',
    plural: 'Квартиры',
    group: 'Группа квартир',
  },
  street: {
    base: 'Улица',
    plural: 'Улицы',
    group: 'Группа улиц',
  },
  city: {
    base: 'Населенный пункт',
    plural: 'Населенные пункты',
    group: 'Группа населенных пунктов',
  },
  region: {
    base: 'Регион',
    plural: 'Регионы',
    group: 'Группа регионов',
  },
  contractNumber: {
    base: 'Номер контракта',
    plural: 'Номера контрактов',
    group: 'Группа номеров контрактов',
  },
  house: {
    base: 'Дом',
    plural: 'Дома',
    group: 'Группа домов',
  },
  requestStatus: {
    base: 'Статус заявки',
    plural: 'Статусы заявок',
    group: 'Группа статусов заявок',
  },
} as const;

export const STATUS_TITLES = {
  CREATED: 'Создана',
  DELAYED: 'Недопуск',
  NOTIFYING: 'Уведомление',
  READY_TO_PROCESS: 'Готова к исполнению',
  IN_PROGRESS: 'Выполняется',
  EXECUTED: 'Выполнена',
  CANCELLED: 'Отменена',
  REJECTED: 'Отклонена',
  DONE: 'Завершена',
  APPROVED: 'Принята заказчиком',
} as const;
